import { IColumn } from '@fluentui/react';
import { ClassNamesFromIStyles, useClassNames } from '@h2oai/ui-kit';
import { ChartData } from 'chart.js';

import { lineChartOptions } from '../../../common/utils';
import DataTable from '../../DataTable/DataTable';
import LineChart from '../../LineChart/LineChart';
import { EScorerErrorEntry, EScorerLatencyEntry } from '../EScorer.utils';
import { eScorerDataDisplayStylesDefault, IEScorerDataDisplayStyles } from './EScorerDataDisplay.styles';

interface IEScorerDataDisplayProps {
  chartData: ChartData<'line'>;
  chartTitle: string;
  tableData: EScorerLatencyEntry[] | EScorerErrorEntry[];
  tableColumns: IColumn[];
  loading?: boolean;
  error?: boolean;
  sortableFields?: string[];
  groupableFields?: string[];
}

const EScorerDataDisplay = ({
  chartData,
  chartTitle,
  tableData,
  tableColumns,
  loading,
  error,
  sortableFields,
  groupableFields,
}: IEScorerDataDisplayProps) => {
  const classNames = useClassNames<IEScorerDataDisplayStyles, ClassNamesFromIStyles<IEScorerDataDisplayStyles>>(
    'escorer-data-display',
    eScorerDataDisplayStylesDefault
  );
  return (
    <div>
      <div className={classNames.chartWrapper}>
        <LineChart
          data={chartData}
          options={lineChartOptions(chartTitle, chartData && chartData.labels?.length ? chartData.labels?.length : 0)}
          loading={loading}
          error={error}
        />
      </div>
      <DataTable
        items={tableData}
        columns={tableColumns}
        searchPlaceholder={'Search by Model Name'}
        searchFields={['modelName']}
        contentHeight="calc(100vh - 260px)"
        loading={loading}
        error={error}
        sortableFields={sortableFields}
        groupableFields={groupableFields}
      />
    </div>
  );
};

export default EScorerDataDisplay;
